import { render, staticRenderFns } from "./ModalMateriaisDropdown.vue?vue&type=template&id=66a477ef&scoped=true&"
import script from "./ModalMateriaisDropdown.vue?vue&type=script&lang=js&"
export * from "./ModalMateriaisDropdown.vue?vue&type=script&lang=js&"
import style0 from "./ModalMateriaisDropdown.vue?vue&type=style&index=0&id=66a477ef&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66a477ef",
  null
  
)

export default component.exports